import { Controller } from "@hotwired/stimulus"

// New/edit matrix binding: pick a document, then a part within it. The part list
// is rebuilt from the chosen document; the first option is always "New part"
// (empty value), which the server materializes on publish. On edit the bound part is preselected.
export default class extends Controller {
  static targets = ["documentSelect", "partSelect"]
  static values = { partsByDocument: Object }

  connect() {
    // Used only on first render to restore the saved selection (the part
    // <select> is rendered empty and populated here).
    this.pendingPartId = this.partSelectTarget.dataset.currentPartId || ""
    this.syncParts()
  }

  syncParts() {
    if (!this.hasDocumentSelectTarget || !this.hasPartSelectTarget) return

    const documentId = this.documentSelectTarget.value
    const desired = this.pendingPartId != null ? this.pendingPartId : this.partSelectTarget.value
    this.pendingPartId = null

    const parts = this.partsByDocumentValue[documentId] || []
    const autoLabel = this.partSelectTarget.dataset.autoLabel || ""

    this.partSelectTarget.innerHTML = ""
    this.partSelectTarget.appendChild(new Option(autoLabel, ""))
    parts.forEach((part) => {
      this.partSelectTarget.appendChild(new Option(part.name, part.id))
    })

    this.partSelectTarget.value =
      parts.some((part) => String(part.id) === String(desired)) ? desired : ""
  }
}
